import { c as _c } from "react/compiler-runtime";
import type React from 'react';
export const MathIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  const $ = _c(6);
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path stroke="none" d="M0 0h24v24H0z" fill="none" />;
    t1 = <path d="M19 5h-7l-4 14l-3 -6h-2" />;
    t2 = <path d="M14 13l6 6" />;
    t3 = <path d="M14 19l6 -6" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== props) {
    t4 = <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>{t0}{t1}{t2}{t3}</svg>;
    $[4] = props;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};